(()=>{'use strict';
const gate=document.querySelector('[data-mission-intro]');
if(!gate)return;
const accept=gate.querySelector('[data-mission-enter]');
const brief=gate.querySelector('[data-mission-briefing]');
const access=gate.querySelector('[data-mission-access]');
const form=gate.querySelector('[data-mission-code-form]');
const code=gate.querySelector('[data-mission-code]');
const feedback=gate.querySelector('[data-mission-feedback]');
const back=gate.querySelector('[data-mission-back]');
const bar=gate.querySelector('[data-mission-bar]');
const status=gate.querySelector('[data-mission-status]');
const heading=gate.querySelector('#brief-title');
const accessHeading=gate.querySelector('#mission-access-title');
const key='wib_mission_war_v3';
let lastFocus=null;
let leaving=false;
const reduced=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const seen=()=>{try{return sessionStorage.getItem(key)==='1'}catch(_){return false}};
const save=()=>{try{sessionStorage.setItem(key,'1')}catch(_){}};
function showBrief(){
  brief.hidden=false; access.hidden=true;
  gate.setAttribute('aria-labelledby','brief-title');
  code.value='';code.removeAttribute('aria-invalid');feedback.textContent='SECURE ACCESS REQUIRED';
  if(bar)bar.style.width='5%';
  if(status)status.textContent='AWAITING YOUR ORDERS';
  accept.focus();
}
function open(){
  lastFocus=document.activeElement;leaving=false;
  gate.hidden=false;gate.classList.remove('is-exiting');
  document.body.classList.add('mission-open');
  showBrief();
}
function close(){
  gate.hidden=true;gate.classList.remove('is-exiting');
  document.body.classList.remove('mission-open');
  if(lastFocus&&typeof lastFocus.focus==='function')lastFocus.focus();
}
function proceed(){
  brief.hidden=true;access.hidden=false;
  gate.setAttribute('aria-labelledby','mission-access-title');
  code.focus();
}
function unlock(){
  if(leaving)return;
  if(code.value.trim().toUpperCase()!=='WAR'){
    code.setAttribute('aria-invalid','true');
    feedback.textContent='ACCESS DENIED — INCORRECT CODE. TRY AGAIN.';
    code.value='';code.focus();return;
  }
  leaving=true;save();code.removeAttribute('aria-invalid');
  feedback.textContent='ACCESS GRANTED — DEPLOYING TO WAR ROOM';
  gate.classList.add('mission-successful');
  const finish=()=>{close();gate.classList.remove('mission-successful')};
  if(reduced()){finish();return}
  gate.classList.add('is-exiting');
  window.setTimeout(finish,650);
}
accept.addEventListener('click',proceed);
back.addEventListener('click',showBrief);
form.addEventListener('submit',e=>{e.preventDefault();unlock()});
code.addEventListener('input',()=>{code.removeAttribute('aria-invalid');feedback.textContent='AWAITING DEPLOYMENT CODE'});
gate.addEventListener('keydown',e=>{
  if(e.key==='Escape'){e.preventDefault();return}
  if(e.key==='Tab'){
    const visible=Array.from(gate.querySelectorAll('button:not([disabled]),input:not([disabled])')).filter(el=>el.getClientRects().length>0&&el.offsetParent!==null);
    if(!visible.length)return;
    const first=visible[0],last=visible[visible.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  }
});
document.querySelectorAll('[data-mission-replay]').forEach(b=>b.addEventListener('click',open));
if(!seen())open();
})();